export default {
  getRandomNumber: function(min, max) {
    return ((Math.random() * (max - min + 1)) + min) << 0
  }
}
